import {
  loadTablesSettings,
  saveTablesSettings,
} from "../services/tablesSettingsService";

export const APPLY_SETTINGS_TABLES = "APPLY_SETTINGS_TABLES";
export const SAVE_SETTINGS_TABLES = "SAVE_SETTINGS_TABLES";
export const LOAD_SETTINGS_TABLES = "LOAD_SETTINGS_TABLES";

const initState = {
  evenRows: {
    background: "#4f5053f1",
    fontSize: "12px",
    color: "#ffffff",
    fontWeight: "normal",
  },
  oddRows: {
    background: "#2c2d30",
    fontSize: "12px",
    color: "#ffffff",
    fontWeight: "normal",
  },
  maxScore: {
    background: "#192A07",
    fontSize: "12px",
    color: "#ffffff",
    fontWeight: "normal",
  },
  frameContainer: {
    background: "#192A07",
    fontSize: "12px",
    color: "#ffffff",
    fontWeight: "normal",
  },
  sectionContainerBackground: "hsla(0,0%,100%,0.8)",
};

export function tableSettings(store) {
  store.on("@init", () => {
    return { tableSettings: initState };
  });

  store.on(APPLY_SETTINGS_TABLES, ({ tableSettings }, data) => {
    localStorage.setItem("tableSettings", JSON.stringify({ ...data }));
    const newData = formatLoadedData(data.settings);
    return { tableSettings: { ...newData } };
  });

  store.on(LOAD_SETTINGS_TABLES, async ({ auth }) => {
    if (auth) {
      const res = await loadTablesSettings(auth);
      const data = res.settings.settings ? res.settings : res;
      store.dispatch(APPLY_SETTINGS_TABLES, data);
    }
  });

  store.on(
    SAVE_SETTINGS_TABLES,
    async ({ tableSettings, auth }, { data, history }) => {
      try {
        if (auth) {
          const settingsData = formatDataToSave(data);
          const res = await saveTablesSettings(auth, {
            settings: settingsData,
          });
          store.dispatch(APPLY_SETTINGS_TABLES, res);
          history.push("/live-score-players");
        }
      } catch (error) {
        console.log(error);
      }
    }
  );

  const formatDataToSave = (data) => {
    return {
      even_rows: {
        background_color: data.evenRows.background,
        font_size: data.evenRows.fontSize,
        color: data.evenRows.color,
        font_weight: data.evenRows.fontWeight,
      },
      odd_rows: {
        background_color: data.oddRows.background,
        font_size: data.oddRows.fontSize,
        color: data.oddRows.color,
        font_weight: data.oddRows.fontWeight,
      },
      max_score: {
        background_color: data.maxScore.background,
        font_size: data.maxScore.fontSize,
        color: data.maxScore.color,
        font_weight: data.maxScore.fontWeight,
      },
      frame_container: {
        background_color: data.frameContainer.background,
        font_size: data.frameContainer.fontSize,
        color: data.frameContainer.color,
        font_weight: data.frameContainer.fontWeight,
      },
      section_container_background: data.sectionContainerBackground,
    };
  };

  const formatLoadedData = (data) => {
    return {
      evenRows: {
        background: data.even_rows.background_color,
        fontSize: data.even_rows.font_size,
        color: data.even_rows.color,
        fontWeight: data.even_rows.font_weight,
      },
      oddRows: {
        background: data.odd_rows.background_color,
        fontSize: data.odd_rows.font_size,
        color: data.odd_rows.color,
        fontWeight: data.odd_rows.font_weight,
      },
      maxScore: {
        background: data.max_score.background_color,
        fontSize: data.max_score.font_size,
        color: data.max_score.color,
        fontWeight: data.max_score.font_weight,
      },
      frameContainer: {
        background: data.frame_container.background_color,
        fontSize: data.frame_container.font_size,
        color: data.frame_container.color,
        fontWeight: data.frame_container.font_weight,
      },
      sectionContainerBackground: data.section_container_background,
    };
  };
}
